import { render, staticRenderFns } from "./RemixerAppAFA.vue?vue&type=template&id=0b879620&scoped=true&"
import script from "./RemixerAppAFA.vue?vue&type=script&lang=js&"
export * from "./RemixerAppAFA.vue?vue&type=script&lang=js&"
import style0 from "./RemixerAppAFA.vue?vue&type=style&index=0&id=0b879620&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b879620",
  null
  
)

export default component.exports